export default __webpack_public_path__ + "static/logo-florette-0713515124bbb0b8aa6aa1223795052f.png";